import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { Panel } from 'primereact/panel';
import { ProgressSpinner } from 'primereact/progressspinner';
import { InputComponent } from '../../../../components/InputComponent';
import { ProveedorService } from '../../../../service/ProveedorService';
import * as generic from '../../../../components/Generico';
import { InfoRepresentante } from '../../../../models/ficha/InfoRepresentante';
import { AccionistaSocios } from '../../AccionistaSocios';
import { ActividadBienServicio } from '../../common/ActividadBienServicio';
import { DeclaranteProveedor } from '../../common/DeclaranteProveedor';
import { BottomActionBar } from '../../../../components/ui/BottomActionBar';

export const DatosRepresentante = ({ toast, id, permss, catalogos, handlePrev, next, nuevoProveedor, soloLectura }) => {

    const esTipoEspecial = ['FRM_TOYOTA', 'FRM_DIFARE'].includes(catalogos?.tipoFrmEmpresa);
    const omodel = new InfoRepresentante({ tipoFrmEmpresa: catalogos?.tipoFrmEmpresa });
    const defaultValues = generic.funDefault(omodel.model);
    const { control, formState: { errors }, handleSubmit, reset, setError, getValues, setValue } = useForm({ defaultValues, shouldTrim: true });
    const proveedorServicio = new ProveedorService();
    const [tipoPersona, setTipoPersona] = useState(null);
    const [tituloDeclarante, setTituloDeclarante] = useState("Datos Representante Legal / Apoderado");
    const { inNumber, inArea, inDrop, inText, inCalendar } = InputComponent({ omodel, errors, control, permss, id, soloLectura });
    // Estados de interfaz y persistencia
    const [isLoading, setIsLoading] = useState(true);
    const [isSaving, setIsSaving] = useState(false);
    const [siCotiza, setSiCotiza] = useState(false);
    const [siReforma, setSiReforma] = useState(false);

    useEffect(() => {
        editFicha();
        // eslint-disable-next-line
    }, [id]);

    const onSubmit = (data) => {
        setIsSaving(true);
        data.id = id;
        data.seccion = 'seccion2';
        data.tipoFrmEmpresa = catalogos?.tipoFrmEmpresa;
        data.tipoPersona = tipoPersona?.nemonico;
        data.cotizaBolsa = catalogos?.cotizaBolsa;

        if (catalogos?.tipoFrmEmpresa === 'FRM_DIFARE' && siReforma) {
            data.fecha_reforma = generic.dateToString(data.fecha_reforma);
        }

        proveedorServicio.editarProveedor(data).then(res => {
            nuevoProveedor(res.data);
            generic.funcSuccess(res, toast);
            next();
        }).catch(error => {
            generic.funcError(error, toast, setError);
        }).finally(() => {
            setIsSaving(false);
        });
    }

    const editFicha = () => {
        setIsLoading(true);
        proveedorServicio.consultarProveedor(id, { seccion: 'seccion2', tipoFrmEmpresa: catalogos?.tipoFrmEmpresa }).then(res => {
            const _prov = res.data.proveedor;
            const tipoPersonaMap = { PRO_REP_LEGAL: 'JURIDICA', PRO_PROPIETARIO: 'NATURAL' };
            const declarante = catalogos?.declarante?.find(
                item => tipoPersonaMap[item.nemonico] === _prov.tipo_persona
            );
            setTipoPersona(declarante ?? null);

            if (esTipoEspecial) {
                setTituloDeclarante("DATOS DEL REPRESENTANTE LEGAL PARA PERSONAS JURÍDICAS O PROPIETARIO PARA PERSONA NATURAL:");
                if (catalogos?.tipoFrmEmpresa === 'FRM_DIFARE') {
                    setSiCotiza(_prov.bolsa_valor === catalogos?.cotizaBolsa?.cat_id);
                    setSiReforma(_prov.reforma_estatuto?.cat_id);

                    if (_prov.reforma_estatuto) _prov.fecha_reforma = generic.stringToDate(_prov.fecha_reforma);
                }
            }

            reset(generic.renewValues(_prov, omodel.model));
        }).finally(() => {
            setIsLoading(false);
        });
    }

    const onError = () => {
        toast.current.show({ severity: 'error', summary: 'Error', detail: 'Se detectaron errores, por favor revise el formulario para corregir.', life: 3000 });
    }

    if (isLoading) {
        return (
            <div className="flex flex-column align-items-center justify-content-center p-5">
                <ProgressSpinner style={{ width: '50px', height: '50px' }} strokeWidth="4" animationDuration=".5s" />
                <span className="mt-3 text-color-secondary font-medium text-lg">Consultando información...</span>
            </div>
        );
    }

    const actualizarPatrimonio = (e, esActivo) => {
        const _campo = esActivo ? 'activo' : 'pasivo';
        const _value = getValues(_campo);
        const _patrimonio = _campo === 'activo' ? _value - getValues('pasivo') : getValues('activo') - _value;
        setValue('patrimonio', _patrimonio);
    }

    const onChangeBolsa = (e) => {
        const _siCotiza = e.value?.cat_id === catalogos?.cotizaBolsa?.cat_id;
        setSiCotiza(_siCotiza);
        if (!_siCotiza) {
            setValue('detalle_bolsa', '');
        }
    }

    const onChangeReforma = (e) => {
        const _siReforma = e.value?.cat_id === true;
        setSiReforma(_siReforma);
        if (!_siReforma) {
            setValue('detalle_reforma', '');
            setValue('fecha_reforma', null);
            setValue('cambio_reforma', '');
        }
    }

    return (
        <>
            <form id="datosInformacionRepresentante" onSubmit={handleSubmit(onSubmit, onError)} className="p-fluid">

                <Panel header={generic.renderPanelHeader('', 'INFORMACIÓN ECONÓMICA', 'pi pi-dollar')} className="panel-ficha shadow-1 mb-4">
                    <div className="formgrid grid">
                        {omodel.model.activo.table && (
                            <>
                                <div className="col-12 mb-3">
                                    <div className="flex align-items-center">
                                        <span className="text-800 font-bold text-base mr-3 flex align-items-center gap-2">
                                            <i className="pi pi-wallet text-primary"></i>
                                            DECLARACIÓN PATRIMONIAL (USD)
                                        </span>
                                        <div className="border-bottom-1 border-300 flex-grow-1" style={{ height: '1px' }}></div>
                                    </div>
                                </div>
                                {inNumber('activo', 2, true, { icon: 'pi pi-money-bill', iconPosition: 'left', func: actualizarPatrimonio, vars: true }, 4)}
                                {omodel.model.pasivo.table && inNumber('pasivo', 2, true, { icon: 'pi pi-money-bill', iconPosition: 'left', func: actualizarPatrimonio, vars: false }, 4)}
                                {omodel.model.patrimonio.table && inNumber('patrimonio', 2, true, { icon: 'pi pi-wallet', iconPosition: 'left', disabled: 'disabled' }, 4)}
                            </>
                        )}

                        <div className={`col-12 mb-3 ${omodel.model.activo.table ? 'mt-3' : ''}`}>
                            <div className="flex align-items-center">
                                <span className="text-800 font-bold text-base mr-3 flex align-items-center gap-2">
                                    <i className="pi pi-chart-line text-primary"></i>
                                    DECLARACIÓN DE INGRESOS Y EGRESOS (USD)
                                </span>
                                <div className="border-bottom-1 border-300 flex-grow-1" style={{ height: '1px' }}></div>
                            </div>
                        </div>

                        {inNumber('INGR_MENSUAL', 2, true, { icon: 'pi pi-money-bill', iconPosition: 'left' }, (omodel.model.INGR_ANUAL.table || omodel.model.EGRE_ANUAL.table) ? 3 : 6)}
                        {inNumber('EGRE_MENSUAL', 2, true, { icon: 'pi pi-money-bill', iconPosition: 'left' }, (omodel.model.INGR_ANUAL.table || omodel.model.EGRE_ANUAL.table) ? 3 : 6)}
                        {omodel.model.INGR_ANUAL.table && inNumber('INGR_ANUAL', 2, true, { icon: 'pi pi-wallet', iconPosition: 'left' }, 3)}
                        {omodel.model.EGRE_ANUAL.table && inNumber('EGRE_ANUAL', 2, true, { icon: 'pi pi-wallet', iconPosition: 'left' }, 3)}
                    </div>
                </Panel>

                {catalogos?.tipoFrmEmpresa === 'FRM_DIFARE' && tipoPersona?.nemonico === 'PRO_REP_LEGAL' && (
                    <Panel header={generic.renderPanelHeader('2', 'DATOS DE LA PERSONA JURÍDICA', 'pi pi-chart-line')} className="panel-ficha shadow-1 mb-4">
                        <div className="col-12 mb-3">
                            <div className="flex align-items-center">
                                <span className="text-800 font-bold text-base mr-3 flex align-items-center gap-2">
                                    <i className="pi pi-building text-primary"></i>
                                    INFORMACIÓN CORPORATIVA Y FINANCIERA
                                </span>
                                <div className="border-bottom-1 border-300 flex-grow-1" style={{ height: '1px' }}></div>
                            </div>
                        </div>

                        <div className="formgrid grid">
                            {inDrop('finalidad', catalogos?.finalidad, { lab: omodel.optionLabel }, siCotiza ? 3 : 4)}
                            {inDrop('registro_mercantil', catalogos?.registroMercantil, { lab: omodel.optionLabel }, siCotiza ? 3 : 4)}
                            {inDrop('bolsa_valor', catalogos?.bolsa, { lab: omodel.optionLabel, chn: onChangeBolsa }, siCotiza ? 3 : 4)}
                            {siCotiza && inText('detalle_bolsa', { icon: 'pi pi-user' }, 3)}

                            {inDrop('tipo_empresa', catalogos?.tipoEmpresa, { lab: omodel.optionLabel }, 3)}
                            {inNumber('venta_mensual', 2, true, { icon: 'pi pi-wallet', iconPosition: 'left' }, 3)}
                            {inNumber('costo_gasto_mensual', 2, true, { icon: 'pi pi-wallet', iconPosition: 'left' }, 3)}
                            {inNumber('utilidad_mensual', 2, true, { icon: 'pi pi-wallet', iconPosition: 'left' }, 3)}
                        </div>

                        <div className="my-3">
                            <ActividadBienServicio id={id} toast={toast} tipo='proveedor' permss={permss} soloLectura={soloLectura} />
                        </div>

                        <div className="col-12 mb-3 mt-4">
                            <div className="flex align-items-center">
                                <span className="text-800 font-bold text-base mr-3 flex align-items-center gap-2">
                                    <i className="pi pi-file-edit text-primary"></i>
                                    REFORMA DE ESTATUTOS
                                </span>
                                <div className="border-bottom-1 border-300 flex-grow-1" style={{ height: '1px' }}></div>
                            </div>
                        </div>

                        <div className="formgrid grid">
                            {inDrop('reforma_estatuto', generic.estadosSiNo, { lab: omodel.optionLabel, chn: onChangeReforma }, siReforma ? 6 : 12)}
                            {siReforma && inCalendar('fecha_reforma', { icon: 'pi pi-calendar', iconPosition: 'left' }, 6)}
                            {siReforma && inArea('cambio_reforma', 3, 350, 6)}
                            {siReforma && inArea('detalle_reforma', 3, 350, 6)}
                        </div>
                    </Panel>
                )}

                <Panel header={generic.renderPanelHeader('2', tituloDeclarante, 'pi pi-users')} className="panel-ficha shadow-1 mb-4">
                    <DeclaranteProveedor id={id} toast={toast} catalogos={catalogos} permss={permss} tipo='proveedor' soloLectura={soloLectura} tipoPersona={null} />
                </Panel>

                {tipoPersona?.nemonico === 'PRO_REP_LEGAL' && (
                    <Panel header={generic.renderPanelHeader('3', 'INFORMACIÓN DE LOS SOCIOS/ACCIONISTAS (APLICA SOLO PARA PERSONAS JURÍDICAS)', 'pi pi-chart-line')} className="panel-ficha shadow-1 mb-4">
                        <div className="p-3 text-justify line-height-3 text-700 bg-blue-50 border-round border-left-3 border-blue-500 mb-4">
                            <div className="flex align-items-center gap-2 mb-2">
                                <i className="pi pi-info-circle text-blue-600 text-lg"></i>
                                <span className="font-bold text-blue-900">Nota Importante</span>
                            </div>
                            Solo en el caso de que el socio / accionista sea persona jurídica consignar la siguiente información hasta llegar a la persona natural.
                        </div>
                        <AccionistaSocios toast={toast} tipo='proveedor' id={id} permss={permss} tipoFrmEmpresa={catalogos?.tipoFrmEmpresa} soloLectura={soloLectura} />
                    </Panel>
                )}

                {omodel.model.detalle.table && (
                    <Panel header={generic.renderPanelHeader('4', 'Detalle de Productos o Servicios que ofrece en el Mercado', 'pi pi-briefcase')} className="panel-ficha shadow-1 mb-4">
                        <div className="formgrid grid">
                            <div className="col-12 mb-3">
                                <div className="flex align-items-center">
                                    <span className="text-800 font-bold text-base mr-3 flex align-items-center gap-2">
                                        <i className="pi pi-briefcase text-primary"></i>
                                        DESCRIPCIÓN DE LA OFERTA COMERCIAL
                                    </span>
                                    <div className="border-bottom-1 border-300 flex-grow-1" style={{ height: '1px' }}></div>
                                </div>
                            </div>
                            {inArea('detalle', 3, 1000, 12)}
                        </div>
                    </Panel>
                )}

                <BottomActionBar formId="datosInformacionRepresentante" onPrev={handlePrev} onNext={next} loading={isSaving} isReadOnly={soloLectura} />
            </form>
        </>
    );
}